<template>
  <el-dialog
    class="customDialogForm"
    width="600px"
    :title="'服务续费'"
    :visible.sync="dialogVisible"
    :before-close="handleClose"
  >
    <el-form
      autocomplete="on"
      style="padding: 0 90px"
      ref="Forms"
      label-position="left"
      :model="captchaForm"
      @submit.native.prevent
    >
      <el-form-item
        prop="appname"
        label="应用名称"
        :label-width="formLabelWidth"
      >
        <el-input
          :disabled="true"
          style="width: 100%; line-height: 37px"
          v-model="captchaForm.name"
        />
      </el-form-item>
      <div>
        <el-form-item
          prop="price"
          :label="'单价' + '(元/' + showDateZh[captchaForm.billCycle] + ')'"
          :label-width="formLabelWidth"
        >
          <el-input :disabled="true" v-model="captchaForm.price" :min="1" />
        </el-form-item>
        <el-form-item
          prop="num"
          label="续费数量:"
          :label-width="formLabelWidth"
        >
          <el-input-number
            style="width: 100%; line-height: 37px"
            v-model="captchaForm.num"
            @change="handleChange"
            :min="1"
          />
        </el-form-item>
        <el-form-item
          prop="total"
          label="总计金额:"
          :label-width="formLabelWidth"
          >{{ totalPrice }}元</el-form-item
        >
      </div>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="submit" :loading="Loading">
        确 定
      </el-button>
    </div>

  </el-dialog>
</template>

<script>
import { errorHandle } from '@/utils/error';

export default {
  name: 'DialogRenewal',
  components: {
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: true
    },
    appDetail: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      Loading: false,
      formLabelWidth: '100px',
      orderType: 'renew',
      captchaForm: {
        num: 1,
        captcha_id: '',
        captcha_answer: '',
        price: 0,
        billCycle: '',
        name: ''
      },
      totalPrice: 0,
      billCycles: [
        {
          label: '周',
          value: 'week'
        },
        {
          label: '月',
          value: 'month'
        },
        {
          label: '季',
          value: 'quarter'
        },
        {
          label: '年',
          value: 'year'
        }
      ],
      value: '',
      loading: false,
      showDateZh: { month: '月', year: '年', quarter: '季度', week: '周' },
      // 微信支付相关
      wechatPayVisible: false,
      wechatPayCodeUrl: '',
      wechatPayAmount: 0,
      wechatPayExpireTime: null,
      currentOrderID: ''
    };
  },
  created() {
    if (this.appDetail) {
      const { combo, appName } = this.appDetail;
      if (combo) {
        this.captchaForm.billCycle = combo.billCycle;
        this.captchaForm.price = combo.comboPrice;
        this.totalPrice = combo.comboPrice * 1;
      }
      this.captchaForm.name = appName;
    }
  },
  methods: {
    submit() {
      this.$refs.Forms.validate((valid) => {
        if (valid) {
          this.Loading = true;
          const { appID, appVersion, combo, appKeyID, marketID } =
            this.appDetail;
          const obj = {
            marketID,
            finalPrice: this.totalPrice,
            orderApps: [
              {
                appID: appKeyID,
                appVersion: appVersion,
                comboID: combo.comboID,
                comboQuantity: this.captchaForm.num,
                deliveryAppID: appID
              }
            ],
            orderType: this.orderType,
            totalPrice: this.totalPrice
          };
          this.$store
            .dispatch('AppRenewal', obj)
            .then((res) => {
              if (res && res.orderID) {
                this.currentOrderID = res.orderID;
                // 创建订单成功后，调用微信支付
                this.createWechatPayOrder(res.orderID);
              } else {
                this.Loading = false;
              }
            })
            .catch(() => {
              this.Loading = false;
            });
        }
      });
    },
    handleChange() {
      const { price, num } = this.captchaForm;
      this.totalPrice = price * num;
    },
    handleClose(_, updata = false) {
      this.$emit('handleClose', updata);
      this.$refs.Forms.resetFields();
    },
    // 创建微信支付订单
    createWechatPayOrder(orderID) {
      this.$store
        .dispatch('CreateWechatPay', orderID)
        .then((res) => {
          this.Loading = false;
          if (res && res.data) {
            const { codeUrl, amount, expireTime } = res.data;
            this.wechatPayCodeUrl = codeUrl;
            this.wechatPayAmount = amount;
            this.wechatPayExpireTime = expireTime;
            this.wechatPayVisible = true;
          }
        })
        .catch((err) => {
          this.Loading = false;
          errorHandle(err);
        });
    },
    // 支付成功处理
    handlePaySuccess() {
      this.wechatPayVisible = false;
      this.$message.success('支付成功');
      this.handleClose(true, true);
      this.$router.push({
        name: 'payStatus',
        params: {
          orderID: this.currentOrderID
        }
      });
    },
    // 取消支付处理
    handlePayCancel() {
      this.wechatPayVisible = false;
      this.$message.info('已取消支付');
      this.handleClose(true, false);
    },
    // 刷新二维码
    handlePayRefresh() {
      this.createWechatPayOrder(this.currentOrderID);
    },
    // 二维码过期处理
    handlePayExpired() {
      this.$message.warning('支付二维码已过期，请刷新重试');
    }
  }
};
</script>

<style lang="scss">
.input-with-select .el-input-group__prepend {
  background: #f9f9f9;
}
.verification-item {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/views/enterpriseApp/components/renew.vue